import React, { useState } from "react";
import { AuthModal } from "@/components";
import {
  HeartSecurityIcon,
  ModerationIcon,
  VerifiedIcon,
  PrivacyIcon,
  VisibilityIcon,
} from "@/svgs";
import "./Guidelines.css";

const GuidelinesScreen: React.FC = () => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  return (
    <div className="guidelines-page">
      <section className="guidelines-hero">
        <div className="v2-container">
          <div className="guidelines-hero-content">
            <span className="v2-sub-title">DIRETRIZES DA COMUNIDADE</span>

            <h1>
              Criando conexões <br />
              <span className="v2-gold-text">com respeito e segurança</span>
            </h1>

            <p>
              Nossa plataforma foi criada para proporcionar conexões reais em um
              ambiente seguro, respeitoso e transparente para todos os usuários.
            </p>
          </div>
        </div>
      </section>

      <section className="guidelines-intro">
        <div className="v2-container">
          <div className="guidelines-intro-box">
            <HeartSecurityIcon />

            <h2>Nosso compromisso com a comunidade</h2>

            <p>
              Esperamos que todos os usuários utilizem a plataforma com
              respeito, honestidade e responsabilidade.
            </p>

            <p>
              Qualquer comportamento que coloque outros usuários em risco poderá
              resultar em remoção de conteúdo, suspensão ou banimento da conta.
            </p>
          </div>
        </div>
      </section>

      <section className="guidelines-rules">
        <div className="v2-container">
          <div className="guidelines-header">
            <span className="v2-sub-title">REGRAS DA PLATAFORMA</span>

            <h2>
              O que <span className="v2-gold-text">não é permitido</span>
            </h2>
          </div>

          <div className="guidelines-grid">
            <div className="guidelines-card">
              <VerifiedIcon />

              <h3>Perfis falsos</h3>

              <p>
                Não é permitido utilizar fotos de terceiros, criar identidades
                falsas ou se passar por outra pessoa.
              </p>
            </div>

            <div className="guidelines-card">
              <ModerationIcon />

              <h3>Golpes e fraudes</h3>

              <p>
                Tentativas de golpe, pedidos financeiros suspeitos ou qualquer
                atividade fraudulenta são proibidos.
              </p>
            </div>

            <div className="guidelines-card">
              <PrivacyIcon />

              <h3>Assédio e ameaças</h3>

              <p>
                Comportamentos abusivos, perseguição, intimidação, chantagem ou
                ameaças não serão tolerados.
              </p>
            </div>

            <div className="guidelines-card">
              <VisibilityIcon />

              <h3>Spam e divulgação</h3>

              <p>
                É proibido enviar spam, divulgar serviços excessivamente ou
                compartilhar links maliciosos.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="guidelines-content">
        <div className="v2-container">
          <div className="guidelines-content-wrapper">
            <div className="guidelines-content-box">
              <h3>Conteúdo proibido</h3>

              <ul>
                <li>Nudez explícita ou conteúdo sexual proibido</li>
                <li>Violência extrema ou conteúdo ofensivo</li>
                <li>Discurso de ódio ou discriminação</li>
                <li>Imagens ilegais ou sem autorização</li>
                <li>Conteúdo envolvendo menores de idade</li>
              </ul>
            </div>

            <div className="guidelines-content-box">
              <h3>Segurança em encontros</h3>

              <ul>
                <li>Prefira locais públicos nos primeiros encontros</li>
                <li>Evite compartilhar dados sensíveis rapidamente</li>
                <li>Desconfie de pedidos financeiros</li>
                <li>Informe amigos ou familiares sobre encontros</li>
                <li>Denuncie comportamentos suspeitos</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="guidelines-report">
        <div className="v2-container">
          <div className="guidelines-report-box">
            <ModerationIcon />

            <h2>Como denunciar um usuário</h2>

            <p>
              Caso encontre comportamentos inadequados, perfis falsos ou
              atividades suspeitas, utilize a ferramenta de denúncia disponível
              dentro da plataforma.
            </p>

            <p>
              Nossa equipe analisa manualmente as denúncias para manter a
              comunidade mais segura.
            </p>
          </div>
        </div>
      </section>

      <section className="guidelines-consequences">
        <div className="v2-container">
          <div className="guidelines-header">
            <span className="v2-sub-title">MODERAÇÃO</span>

            <h2>
              Consequências de <span className="v2-gold-text">violações</span>
            </h2>
          </div>

          <div className="guidelines-consequences-grid">
            <div className="guidelines-consequence">
              <span>01</span>

              <h4>Advertência</h4>

              <p>
                Em alguns casos, o usuário poderá receber uma notificação de
                comportamento inadequado.
              </p>
            </div>

            <div className="guidelines-consequence">
              <span>02</span>

              <h4>Suspensão temporária</h4>

              <p>
                Contas podem ser suspensas temporariamente durante análises de
                segurança.
              </p>
            </div>

            <div className="guidelines-consequence">
              <span>03</span>

              <h4>Banimento permanente</h4>

              <p>
                Violações graves podem resultar na remoção permanente da conta.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="guidelines-cta">
        <div className="v2-container">
          <div className="guidelines-cta-content">
            <HeartSecurityIcon />

            <h2>Uma comunidade mais segura para todos</h2>

            <p>
              Trabalhamos constantemente para manter um ambiente respeitoso,
              autêntico e seguro para conexões reais.
            </p>

            <button
              className="v2-btn-gold"
              type="button"
              onClick={() => setIsAuthModalOpen(true)}
            >
              Solicitar Acesso Exclusivo
            </button>
          </div>
        </div>
      </section>

      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
      />
    </div>
  );
};

export default GuidelinesScreen;
